import React, { Component } from "react";
import authService, { AuthenticationResultStatus } from "./AuthorizeService";
import { LoginActions, QueryParameterNames, ApplicationPaths } from "./ApiAuthorizationConstants";

interface Props {
  action: string;
}

interface State {
  message: string | undefined;
}

export class Login extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { message: undefined };
  }

  componentDidMount() {
    const { action } = this.props;
    switch (action) {
      case LoginActions.Login:
        this.login(this.getReturnUrl());
        break;
      case LoginActions.LoginCallback:
        this.processLoginCallback();
        break;
      case LoginActions.LoginFailed: {
        const params = new URLSearchParams(window.location.search);
        const error = params.get(QueryParameterNames.Message);
        this.setState({ message: error ?? "Login failed." });
        break;
      }
      case LoginActions.Profile:
        this.redirectToProfile();
        break;
      case LoginActions.Register:
        this.redirectToRegister();
        break;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }

  render() {
    const { action } = this.props;
    const { message } = this.state;

    if (message) {
      return <div>{message}</div>;
    }

    switch (action) {
      case LoginActions.Login:
        return <div>Processing login</div>;
      case LoginActions.LoginCallback:
        return <div>Processing login callback</div>;
      case LoginActions.Profile:
      case LoginActions.Register:
        return <div></div>;
      default:
        throw new Error(`Invalid action '${action}'`);
    }
  }

  private async login(returnUrl: string) {
    const result = await authService.signIn({ returnUrl });
    switch (result.status) {
      case AuthenticationResultStatus.Redirect:
        break;
      case AuthenticationResultStatus.Success:
        this.navigateToReturnUrl(returnUrl);
        break;
      case AuthenticationResultStatus.Fail:
        this.setState({ message: result.message });
        break;
    }
  }

  private async processLoginCallback() {
    const result = await authService.completeSignIn(window.location.href);
    switch (result.status) {
      case AuthenticationResultStatus.Redirect:
        throw new Error("Should not redirect.");
      case AuthenticationResultStatus.Success:
        this.navigateToReturnUrl(this.getReturnUrl(result.state));
        break;
      case AuthenticationResultStatus.Fail:
        this.setState({ message: result.message });
        break;
    }
  }

  private getReturnUrl(state?: unknown): string {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get(QueryParameterNames.ReturnUrl);
    if (fromQuery && !fromQuery.startsWith(`${window.location.origin}/`)) {
      throw new Error("Invalid return url. The return url needs to have the same origin as the current page.");
    }
    return (state as any)?.returnUrl || fromQuery || `${window.location.origin}/`;
  }

  private redirectToRegister() {
    this.redirectToApiAuthorizationPath(
      `${ApplicationPaths.IdentityRegisterPath}?${QueryParameterNames.ReturnUrl}=${encodeURI(ApplicationPaths.Login)}`,
    );
  }

  private redirectToProfile() {
    this.redirectToApiAuthorizationPath(ApplicationPaths.IdentityManagePath);
  }

  private redirectToApiAuthorizationPath(path: string) {
    window.location.replace(`${window.location.origin}/${path}`);
  }

  private navigateToReturnUrl(returnUrl: string) {
    window.location.replace(returnUrl);
  }
}
